/**
 * Circular dependency prevention:
 * - useStatus
 */
import events$ from '@/services/Events'

import useProduct from '@/hooks/useProduct'
import useStatus from '@/hooks/useStatus'

import { EVENT_CONFIRMATION_MODAL_OPEN } from '@/config/events'
import isEqual from 'lodash/isEqual'

const { isProductReloadNecessary } = useProduct()

async function confirm(label, buttonLabels, title, severity) {
  try {
    await new Promise((resolve, reject) => {
      events$.emit(EVENT_CONFIRMATION_MODAL_OPEN, {
        label,
        buttonLabels,
        title,
        severity,
        resolve,
        reject,
      })
    })
    return true
  } catch {
    return false
  }
}

function isConfirmationNeeded(updated, original) {
  const { isOnboardingSecured } = useStatus()

  if (!isOnboardingSecured.value) return false
  if (isProductReloadNecessary(updated, original)) return true

  if (updated.persons.length !== original.persons.length) return true

  if (!isEqual(updated.address, original.address)) return true

  return updated.persons.some(
    (person, index) =>
      person.personData.dateOfBirth !== original.persons[index].personData.dateOfBirth ||
      person.personData.gender !== original.persons[index].personData.gender ||
      person.collectivePersonGroup !== original.persons[index].collectivePersonGroup
  )
}

export default function useConfirmation() {
  return {
    confirm,
    isConfirmationNeeded,
  }
}
